export const TIME_ESTIMATION = {
	READING: {
		TIME_PER_QUESTION: 1.25, // 1.25 minutes per question
	},
	LISTENING: {
		AVERAGE_ANSWER_TIME: 0.7, // 0.7 minutes per question
	},
	SPEAKING: {
		AVERAGE_TIME_PER_STIMULUS: 4, // 4 minutes per stimulus
	},
	WRITING: {
		ACADEMIC_DISCUSSION_TIME: 10, // 10 minutes
		INTEGRATED_WRITING_TIME: 20, // 20 minutes
	},
	BASE_READING_TIME: 5, // 5 minutes per 700-word passage
};

export const WRITING_NUM_STIMULUS = {
	ACADEMIC_DISCUSSION: 7,
	INTEGRATED_WRITING: 7,
};
